import {
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILED,
  CLEAR_BANKS,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANKS_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case FETCH_BANKS_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_BANKS:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
